import amplitude from 'src/_shared/amplitude';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import { TestIDs } from 'src/constants/testIDs.constants';
import { SecondaryButton } from 'src/editor-v3/components/buttons/secondary-button/SecondaryButton';
import { headerEditorTestID } from 'src/helpers/testIDs.helper';
import { DRAWER_VIEWS, DRAWER_POSITIONS } from 'src/store/drawer/drawer.constants';
import { ProjectSaveButtonProps } from '../ProjectSaveButton.types';

export const ToBeSavedButton = ({
  i18n,
  openDrawer,
  totalNumberOfProducts,
  focusOrder,
  focusGroup,
}: ProjectSaveButtonProps) => {
  return (
    <SecondaryButton
      onPress={async () => {
        amplitude.trackEvent(AnalyticsEvents.project.saveClick, {
          n_photos: totalNumberOfProducts,
        });
        openDrawer({
          drawerView: DRAWER_VIEWS.Login,
          drawerPosition: DRAWER_POSITIONS.Right,
        });
      }}
      accessible={true}
      accessibilityLabel={i18n.t('header:save-project')}
      accessibilityRole="button"
      testID={headerEditorTestID(TestIDs.SAVE)}
      focusId={headerEditorTestID(TestIDs.SAVE)}
      focusOrder={focusOrder}
      focusGroup={focusGroup}
      text={i18n.t('header:save-project')}
    />
  );
};
